import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-282528be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price-info" }
const _hoisted_2 = {
  key: 0,
  class: "price-base"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "number" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "￥", -1))

import { withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'cost-info-item',
  props: {
    buyInfo: { default: () => ({
      price: '',
    }) },
    showDefaualtContent: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { buyInfo: {
      price: string
      title?: string
    }, showDefaualtContent: boolean };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.showDefaualtContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(props?.buyInfo?.title || '极加服务报价'), 1),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(props?.buyInfo?.price), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})